import React, { useContext, useRef } from "react";
import classes from "./ForeignList.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import ForeignCard from "./foreign-card/ForeignCard";
import { useLocation } from "react-router-dom";
import { NavigationContext } from "../../../App";

const ForeignList = ({ data }) => {
  const swiperRef = useRef(null);
  const width = useDeviceWidth();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  const repeatObjects = (arr,number=4) => {
    if (arr.length >= number) return arr; // If already 4 or more, return as is
  
    let repeatedArr = [...arr]; // Clone the original array
  
    while (repeatedArr.length < number) {
      repeatedArr = [...repeatedArr, ...arr]; // Repeat the original array
    }
  
    return repeatedArr.slice(0, Math.max(number, arr.length * 2)); // Ensure correct length
  }

  return (
    <div className={`${classes.outer} bg-primary-100`}>
      <div className={classes.inner}>
        <img src="/img/foreign-pattern.svg" className={classes.pattern} alt="pattern"></img>
        <div className={classes.innerContent}>
          <div className={classes.title} data-aos="fade-down" data-aos-delay="200">
            <h1 className="bg-primary-200">{data?.subTitle}</h1>
            {data?.showTitle && (
              <div>
                <h2 dangerouslySetInnerHTML={{ __html: data?.title }}></h2>
              </div>
            )}
            {/* <div className={`${classes.underLine} bg-primary-500`}></div> */}
          </div>
          <div className={classes.sliderOuter}>
            <div className={classes.arrowDiv}>
              <img
                src="/img/title-symbol.svg"
                className={classes.titleSymbol}
                alt="symbol"
              ></img>
              <div className={classes.arrows}>
                <img
                  className={classes.leftArrow}
                  src="/img/doctor-left.svg"
                  alt="Prev"
                  onClick={() => swiperRef.current?.slidePrev()} // Trigger previous slide
                />
                <img
                  src="/img/doctor-right.svg"
                  className={classes.rightArrow}
                  alt="Next"
                  onClick={() => swiperRef.current?.slideNext()} // Trigger next slide
                />
              </div>
            </div>
            <div className="outer-outer">
              <div>
                {/* Custom Navigation Arrows */}

                {/* Swiper */}
                <Swiper
                  //   modules={[Navigation, Pagination]}
                  slidesPerView={
                    width > 1800
                      ? 5
                      : width > 1200
                      ? 4
                      : width > 900
                      ? 3
                      : width > 550
                      ? 2
                      : 1
                  } // Show 3 images at a time
                  spaceBetween={20} // Add space between slides
                  onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
                  pagination={{ clickable: true }} // Enable clickable dots
                  loop={true} // Enable infinite looping
                  draggable={true} // Enable drag/swipe functionality
                  modules={[Autoplay]}
                  autoplay={{
                    delay: 3000, // 3 seconds
                    disableOnInteraction: false, // Autoplay continues even after interaction
                  }}
                >
                  {repeatObjects(data?.listingItems,6).map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <ForeignCard data={slide} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForeignList;
